import { SpeakingEngagement, Publication, Honor } from '../types/content';

export const speakingEngagements: SpeakingEngagement[] = [
  {
    role: 'Keynote Panelist',
    event: 'E Source Forum',
    detail: '"Industry in Transition"'
  },
  {
    role: 'Guest',
    event: 'The Innovation Storytellers Show',
    detail: 'Episode 84'
  },
  {
    role: 'Presenter',
    event: 'RMEL Spring Conference'
  },
  {
    role: 'Panelist',
    event: 'Spigit Ignite Conference'
  }
];

export const publications: Publication[] = [
  {
    title: "Innovation and Ameren's Corporate Strategy",
    outlet: 'RMEL Winter 2018'
  }
];

export const honors: Honor[] = [
  {
    title: 'Nuclear Energy Institute (NEI) Top Innovative Practice Award',
    detail: 'For grid-monitoring technology deployment'
  },
  {
    title: "3-Time Nominee for Ameren President's Award"
  }
];
